import { wrapRequest } from '@applandeo/api-wrapper';
import { useEffect, useState } from 'react';

import { getRequestStatusChangesHistory } from '@/dataExchange/services/requestsPage.service';
import { DELETION_STATUS, REQUEST_STATUS, REQUEST_STATUS_SPECIFIC_DATA } from '@/utils/enums/requestsPage';

const useRequestInfo = requestDetails => {
    const [approverName, setApproverName] = useState('');
    const { status, _id, statusInRequest } = requestDetails;
    const getRequestStatusChangesHistoryWrapper = wrapRequest(getRequestStatusChangesHistory);

    useEffect(() => {
        if (status === REQUEST_STATUS.NEW) return;
        getRequestStatusChangesHistoryWrapper.fetch(_id).onSuccess(({ changesBy: { firstName, lastName } }) => {
            const approver = `${firstName} ${lastName}`;
            setApproverName(approver);
        });
    }, [_id, status]);

    const isWaitingForDeletion = statusInRequest === DELETION_STATUS.DELETION_REQUEST;
    const statusData = REQUEST_STATUS_SPECIFIC_DATA[isWaitingForDeletion ? DELETION_STATUS.DELETION_REQUEST : status];

    return { approverName, statusData, isWaitingForDeletion };
};

export default useRequestInfo;
